import request from '@/utils/request'
import qs from 'qs'
export function getArriveGuestList(query) {
  return request({
    url: '/report-service/v1/revenue-report/arrive-guest',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getArriveGuestExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/arrive-guest-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
